var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("工作台首页")
              ]),
              _c("el-breadcrumb-item", [_vm._v("订货管理")]),
              _c("el-breadcrumb-item", [_vm._v("出库申请单")]),
              _c("el-breadcrumb-item", [
                _vm._v(
                  _vm._s(_vm.form.id ? "出库申请单详情" : "新增出库申请单")
                )
              ])
            ],
            1
          ),
          _vm.orderRow.orderNumber
            ? _c("div", { staticStyle: { "font-size": "14px" } }, [
                _vm._v(" 申请单号：" + _vm._s(_vm.orderRow.orderNumber) + " ")
              ])
            : _vm._e()
        ],
        1
      ),
      [
        _c(
          "div",
          { staticStyle: { "margin-bottom": "10px" } },
          [
            _vm.form.status === 0
              ? _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.form.appType,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "appType", $$v)
                      },
                      expression: "form.appType"
                    }
                  },
                  [
                    _c("el-radio", { attrs: { label: 1 } }, [
                      _vm._v("临调出库申请")
                    ]),
                    _c("el-radio", { attrs: { label: 2 } }, [
                      _vm._v("直销出库申请")
                    ])
                  ],
                  1
                )
              : _c(
                  "span",
                  [
                    _vm.form.appType === 1
                      ? _c("el-tag", [_vm._v("临调出库申请")])
                      : _vm._e(),
                    _vm.form.appType === 2
                      ? _c("el-tag", [_vm._v("直销出库申请")])
                      : _vm._e()
                  ],
                  1
                )
          ],
          1
        ),
        _c(
          "el-form",
          {
            ref: "form",
            staticClass: "form-table",
            attrs: {
              model: _vm.form,
              rules: _vm.formRules,
              size: "mini",
              "label-width": "140px",
              "label-suffix": ":",
              "show-message": false,
              loading: _vm.formLoading,
              disabled: !(_vm.form.status === 0)
            },
            nativeOn: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c(
              "el-row",
              { staticStyle: { "flex-wrap": "wrap" }, attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  { attrs: { sm: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "经销商", prop: "distributorId" } },
                      [
                        _vm.form.status === 0
                          ? _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  filterable: "",
                                  placeholder: "请选择"
                                },
                                on: { change: _vm.distributorIdChange },
                                model: {
                                  value: _vm.form.distributorId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "distributorId", $$v)
                                  },
                                  expression: "form.distributorId"
                                }
                              },
                              _vm._l(_vm.manufacturerList, function(
                                item,
                                index
                              ) {
                                return _c("el-option", {
                                  key: "distributorId" + index,
                                  attrs: {
                                    label: item.name,
                                    value: item.ID,
                                    disabled: !item.show_status
                                  }
                                })
                              }),
                              1
                            )
                          : _c("div", { staticClass: "item-text" }, [
                              _vm._v(_vm._s(_vm.orderRow.distributorName))
                            ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { sm: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "供应商名称", prop: "subsidiaryId" } },
                      [
                        _vm.subsidiaryList.length > 0
                          ? _c(
                              "div",
                              [
                                _vm.form.status === 0
                                  ? _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          clearable: "",
                                          filterable: "",
                                          placeholder: "请选择"
                                        },
                                        model: {
                                          value: _vm.form.subsidiaryId,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "subsidiaryId",
                                              $$v
                                            )
                                          },
                                          expression: "form.subsidiaryId"
                                        }
                                      },
                                      _vm._l(_vm.subsidiaryList, function(
                                        item,
                                        index
                                      ) {
                                        return _c("el-option", {
                                          key: "subsidiaryName" + index,
                                          attrs: {
                                            label: item.companyName,
                                            value: item.companyName,
                                            disabled: item.isValid !== 1
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  : _c("div", { staticClass: "item-text" }, [
                                      _vm._v(_vm._s(_vm.form.subsidiaryName))
                                    ])
                              ],
                              1
                            )
                          : _c("div", [
                              _c("div", { staticClass: "item-text" }, [
                                _vm._v(_vm._s(_vm.form.subsidiaryName))
                              ])
                            ])
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { sm: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "医院", prop: "hospitalId" } },
                      [
                        _vm.form.status === 0
                          ? _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  filterable: "",
                                  placeholder: "请选择"
                                },
                                model: {
                                  value: _vm.form.hospitalId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "hospitalId", $$v)
                                  },
                                  expression: "form.hospitalId"
                                }
                              },
                              _vm._l(_vm.hospitalList, function(item, index) {
                                return _c("el-option", {
                                  key: "hospitalId" + index,
                                  attrs: {
                                    label: item.username,
                                    value: item.ID
                                  }
                                })
                              }),
                              1
                            )
                          : _c("div", { staticClass: "item-text" }, [
                              _vm._v(_vm._s(_vm.form.hospitalName))
                            ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { sm: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "收货地址", prop: "receiveAddress" } },
                      [
                        _vm.form.status === 0
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { flex: "1" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          clearable: "",
                                          filterable: ""
                                        },
                                        on: { change: _vm.addressChange },
                                        model: {
                                          value: _vm.form.receiveAddressId,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "receiveAddressId",
                                              $$v
                                            )
                                          },
                                          expression: "form.receiveAddressId"
                                        }
                                      },
                                      _vm._l(_vm.addressList, function(
                                        item,
                                        index
                                      ) {
                                        return _c("el-option", {
                                          key: "receiveAddressId" + index,
                                          attrs: {
                                            label: item.address,
                                            value: item.ID
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100px",
                                      "text-align": "center",
                                      "border-left": "1px solid #eee"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-link",
                                      {
                                        attrs: {
                                          underline: false,
                                          type: "primary",
                                          disabled: !(_vm.form.status === 0)
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.newAddress()
                                          }
                                        }
                                      },
                                      [_vm._v("新增地址")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          : _c("div", { staticClass: "item-text" }, [
                              _vm._v(_vm._s(_vm.form.receiveAddress))
                            ])
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { sm: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "收件人", prop: "receiveName" } },
                      [
                        _c("div", { staticClass: "item-text" }, [
                          _vm._v(_vm._s(_vm.form.receiveName))
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { sm: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "收件人联系方式", prop: "contactInfo" }
                      },
                      [
                        _c("div", { staticClass: "item-text" }, [
                          _vm._v(_vm._s(_vm.form.contactInfo))
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { sm: 24, lg: 24, xl: 24 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "remark", label: "备注" } },
                      [
                        _vm.form.status === 0
                          ? _c("el-input", {
                              attrs: {
                                maxlength: "255",
                                "suffix-icon": "el-icon-edit",
                                placeholder: "请输入备注",
                                clearable: ""
                              },
                              model: {
                                value: _vm.form.remark,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "remark", $$v)
                                },
                                expression: "form.remark"
                              }
                            })
                          : _c("div", { staticClass: "item-text" }, [
                              _vm._v(_vm._s(_vm.form.remark))
                            ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-direction": "column",
              "justify-content": "space-between",
              "align-items": "center"
            }
          },
          [
            _c(
              "el-form",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.formLoading,
                    expression: "formLoading"
                  }
                ],
                staticStyle: { margin: "0px", width: "100%" },
                attrs: { size: "small" },
                nativeOn: {
                  submit: function($event) {
                    $event.preventDefault()
                  }
                }
              },
              [
                _c(
                  "el-form-item",
                  { staticStyle: { margin: "0" } },
                  [
                    _vm.form.status === 0
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              disabled: _vm.detailRowIndex >= 0 ? false : true
                            },
                            on: {
                              click: function($event) {
                                return _vm.productRemove()
                              }
                            }
                          },
                          [_vm._v("删除行")]
                        )
                      : _vm._e(),
                    _vm.form.status === 0 && _vm.form.id
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "prevent-re-click",
                                rawName: "v-prevent-re-click"
                              }
                            ],
                            attrs: { type: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.orderInvalid()
                              }
                            }
                          },
                          [_vm._v("作废")]
                        )
                      : _vm._e(),
                    _vm.form.status === 0 && _vm.form.id
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "prevent-re-click",
                                rawName: "v-prevent-re-click"
                              }
                            ],
                            attrs: { type: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.orderDelete()
                              }
                            }
                          },
                          [_vm._v("删除订单")]
                        )
                      : _vm._e(),
                    _vm.form.status === 0
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "prevent-re-click",
                                rawName: "v-prevent-re-click"
                              }
                            ],
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.toFormStorage()
                              }
                            }
                          },
                          [_vm._v("暂存")]
                        )
                      : _vm._e(),
                    _vm.form.status === 0
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "prevent-re-click",
                                rawName: "v-prevent-re-click"
                              }
                            ],
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.formSubmit()
                              }
                            }
                          },
                          [_vm._v("提交")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", disabled: !_vm.form.id },
                        on: { click: _vm.orderPrint }
                      },
                      [_vm._v("打印")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("AddressComponent", {
        ref: "AddressComponentRef",
        on: {
          reload: function($event) {
            return _vm.loadAddress()
          }
        }
      }),
      _c("ProductComponent", {
        ref: "ProductComponentRef",
        on: {
          reload: function($event) {
            return _vm.loadDetail()
          },
          add: _vm.addProductToDetailList
        }
      }),
      _c("PrintComponent", { ref: "PrintComponentRef" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }